import React from "react"
import { TaskType } from "../apis/quadriRestApi"

interface PropertyPanelProps {
  data: TaskType | undefined
}

export const TaskPropertyPanel: React.FC<PropertyPanelProps> = ({ data }) => {
  if (!data) return null
  const renderPropertyValue = (value: any) => {
    if (typeof value === "object" && value !== null) {
      return (
        <ul>
          {Object.entries(value).map(([key, val]) => (
            <li key={key}>
              <strong>{key}:</strong> {JSON.stringify(val)}
            </li>
          ))}
        </ul>
      )
    }
    return value
  }
  return (
    <div className="task-property-panel-container">
      <h2 className="task-property-panel-title">Task Properties</h2>
      <div className="task-property-panel">
        <div className="task-property-section">
          <p>
            <strong>Name:</strong> {data.header.name}
          </p>
          <p>
            <strong>Description:</strong> {data.header.description}
          </p>
          <p>
            <strong>Tag:</strong> {data.header.taskTypeTag}
          </p>
          <p>
            <strong>Created:</strong> {data.header.creationDate}
          </p>
          <p>
            <strong>Modified:</strong> {data.header.lastModifiedDate}
          </p>
          <p>
            <strong>Details:</strong> {data.details?.type?.description || "N/A"}
          </p>
        </div>
        <div className="task-property-table-section">
          <h3 className="task-property-table-title">Properties</h3>
          <table className="task-property-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {data.details?.properties?.map((property, index) => (
                <tr key={index}>
                  <td>{property.definition.caption}</td>
                  <td>{renderPropertyValue(property.value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
